import { Component, Input, ViewChild, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { TranslateService } from '@ngx-translate/core';
import { App, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { CategoriesProvider } from '../../../../providers/categories/categories';
import { ConfigProvider } from '../../../../providers/config/config';
import { EventDetailsModel, EventProvider, RouteInfos } from '../../../../providers/event/event';
import { LoaderProvider } from '../../../../providers/loader/loader';
import { MyPicsListModel, UserProvider, RegistrationModel } from '../../../../providers/user/user';
import { PictureViewerPage } from '../../../picture-viewer/picture-viewer';
import { EventDetailsMapPage } from '../event-details-map/event-details-map';
import { NearbyMapPage } from '../../../nearby/main/nearby-main';
import { NearbyMainResolver } from '../../../nearby/main/nearby-main-resolver';
import { ResultProvider, RanglistSearchModelByID } from '../../../../providers/result/result';
import { SessionProvider } from '../../../../providers/session/session';
import { PopupRegistrationComponent } from '../../../../components/popup-registration/popup-registration';
import { TransDatePipe } from '../../../../pipes/trans-date/trans-date';
import { ResultAddPage } from '../../../results/result-add/result-add';
import { StrackerProvider, TrackerModel } from '../../../../providers/stracker/stracker';
import { GpsTracker } from '../../../../tracker/gps-tracker';
import { EventRegistrationModel } from '../../../../providers/stracker/stracker';
import { IdRegistrationPage } from '../../../login/id-registration/id-registration';
import { GlobalUtil } from '../../../../tracker/global-utils';
import { StrackerPage } from '../../../../tracker/sencha-tracker/stracker';
import { EventDetailsNewDesignResolver } from './event-details-new-design-details-resolver';
import { EventDetailsProvider } from '../../../../providers/event-details/event-details';
import { StorageProvider } from '../../../../providers/storage-service/storage-service';
import { AppDetectorProvider } from '../../../../providers/detector/detector';
import { ResultSearchPage } from '../../../results/result-search/result-search';
import { SettingsProvider } from '../../../../providers/settings/settings';
declare var google;

@Component({
  selector: 'page-event-details-new-design',
  templateUrl: 'event-details-new-design.html'
})
export class EventDetailsNewDesignPage {
  @Input('event') event: any;
  @Input('event-tabs-instance') parentInstance: any;
  @Input('dateFormatted') dateFormatted: string;

  routes: any[] = [];
  filteredImages: MyPicsListModel[] = [];
  options: string[] = [];
  client: {
    arrowPressed: boolean
  } = {
      arrowPressed: false
    };

  titleImage: MyPicsListModel;

  isVirtual: boolean = false; // indicates whether the event is virual or not

  //
  clientSponsor: boolean = false; // sponsor app displays tracker button
  clientLauftreff: boolean = false; // lauftreff app displays button and combobox instead of 'GPS Tracking' and 'Event merken'
  clientEvents: boolean = false; // if it's false then show live results
  clientHannover: boolean = false;
  clientHella: boolean = false;
  //

  @ViewChild('myPlaceholder')
  myPlaceholder: any;

  @ViewChild('uploadButton')
  uploadButton: any;

  startDisabled: boolean = false;
  liveDisabled: boolean = false;

  showMark: boolean = false;

  //UI
  isNullStartDate: boolean = false;
  clientApp: boolean = false;
  isBrowser: boolean = false;
  isRegistered: boolean = false;
  pipeDateFormat = "dd.MM.yyyy";
  
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private eventService: EventProvider,
    private categoryService: CategoriesProvider,
    private app: App,
    private camera: Camera,
    private loadingCtrl: LoaderProvider,
    private iab: InAppBrowser,
    private toastCtrl: ToastController,
    private config: ConfigProvider,
    public modalCtrl: ModalController,
    public translate: TranslateService,
    private nearbyMainResolver: NearbyMainResolver,
    private changeDetector: ChangeDetectorRef,
    private resultService: ResultProvider,
    private sessionService: SessionProvider,
    private transDate: TransDatePipe,
    private strackerService: StrackerProvider,
    private userService: UserProvider,
    private eventDetailsResolver: EventDetailsNewDesignResolver,
    private storageService: StorageProvider,
    private appDetector: AppDetectorProvider,
    private settingsService: SettingsProvider,
    private inAppBrowser: InAppBrowser) {
    new Promise(async (resolve, reject) => {
      this.clientSponsor = (await this.config.config).showHide.trackerButton;
      this.clientLauftreff = (await this.config.config).showHide.lauftreff;
      this.clientHannover = (await this.config.config).appId.includes("hannover") ? true : false;
      this.clientHella = (await this.config.config).appId.includes("hella") ? true : false;
      this.clientEvents = (await this.config.config).appId.includes("events") ? true : false;
      this.settingsService.getActiveDateFormat().then(date => {
        this.pipeDateFormat = date.pipeFormat;
      });

      if (this.sessionService.isLoged)
        this.eventService.isUserRegistered(this.event.id).then(isRegistered => {
          this.isRegistered = isRegistered;
        })

      let name: string = (await this.config.config).appId;
      this.isBrowser = (await this.config.config).platform.browser;

      let eventDate;
      let initData = new Date(this.event.date);

      if (!this.event.endDate || this.event.endDate === 'undefined' || this.event.endDate == 0) {
        eventDate = new Date(this.event.date);

      } else {
        eventDate = new Date(this.event.endDate);
      }
      // console.log('eventDate: ', eventDate);
      let finalDate = new Date(eventDate.getFullYear(), eventDate.getMonth(), eventDate.getDate() + 2, 3);
      console.log('finalDate: ', finalDate);
      let startDate = new Date(initData.getFullYear(), initData.getMonth(), initData.getDate(), 0, 1);
      console.log('startDate: ', startDate);

      this.startDisabled = ((finalDate.getTime() - new Date().getTime()) < 0) ? true : false;
      this.liveDisabled = ((startDate.getTime() - new Date().getTime()) < 0) ? false : true;

      this.clientApp = name.includes("hella") || name.includes("hannover") || name.includes("vivawest") || name.includes("thurnau");

      GlobalUtil.getInstance().currentEventID = this.event.id;
      console.log('GpsTracker.currentEventID: ', GlobalUtil.getInstance().currentEventID);

      if (this.event.name.length < 1) {
        this.eventService.getEventDetails(this.event.id).then((event: EventDetailsModel) => {
          this.event = event;
          this.isVirtual = (this.event.eventType.toUpperCase().includes("V") || this.event.eventType.toUpperCase().includes("S"));
        });
      } else {
        this.isVirtual = (this.event.eventType.toUpperCase().includes("V") || this.event.eventType.toUpperCase().includes("S"));
      }

      this.checkForStartDate();
      this.dummyInitialize();
      resolve(null);
    });
  }

  onTest() {
    this.sessionService.getToken(false, false).then(token => {
      this.strackerService.getResultPreload(this.event.id, this.sessionService.profile.id + "").then((data: TrackerModel) => {
        GpsTracker.sumDistance = 0;
        GpsTracker.currentSpeed = "0";

        (this.app.getRootNav() as NavController).push(StrackerPage, { event: this.event, imageLink: "", data: data, token: this.sessionService.profile.id + "" });
      });
    });
  }

  checkForStartDate() {
    this.dateFormatted = this.transDate.transform(this.event.date, "HH:mm");

    if (this.event.eventType.toUpperCase().includes("V") || this.event.eventType.toUpperCase().includes("S")) {
      this.isNullStartDate = true;
      return;
    } else {
      if (this.dateFormatted.includes("00:00"))
        this.isNullStartDate = true;
    }
  }

  async onRegister() {
    if (this.appDetector.isEventsApp() || this.appDetector.isForestApp() || this.appDetector.isGesunderApp() || this.appDetector.isHellaApp()) {
      // if (!this.sessionService.isLoged) {
      //   new Promise<any>((resolve, reject) => {
      //     (this.app.getRootNav() as NavController).push(LoginPage, { resolve: resolve });
      //   }).then((status) => {
      //     if (status) {
      this.sessionService.getToken(false, false).then(() => {
        (this.checkForGender()) ? this.register() : this.toastMessage(this.translate.instant("GENDER_EVENT_ERROR_MESSAGE"), 5000);
      });
      // }
      // })
      // } else {
      //   this.sessionService.getToken().then(() => {
      //     (this.checkForGender()) ? this.register() : this.toastMessage(this.translate.instant("GENDER_EVENT_ERROR_MESSAGE"), 5000);
      //   });
      // }
    }
    // } else {
    //   this.sessionService.getToken(false, false).then(() => {
    //     (this.checkForGender()) ? this.register() : this.toastMessage(this.translate.instant("GENDER_EVENT_ERROR_MESSAGE"), 5000);
    //   });
    // }
  }


  checkForBrowser() {
    if (this.isBrowser) {
      if (navigator.platform.toLocaleLowerCase().includes("iphone")) {
        alert(this.translate.instant("STORE_NAVIGATION_MESSAGE"));
        window.location.href = "https://apps.apple.com/de/app/spooorts-events/id1223827266?l=en";
      } else if (navigator.userAgent.toLocaleLowerCase().includes("android")) {
        alert(this.translate.instant("STORE_NAVIGATION_MESSAGE"));
        window.location.href = "https://play.google.com/store/apps/details?id=com.spooorts.event";
      }
    }
  }

  checkForGender() {
    if (this.sessionService.profile) {
      if (this.event.wertung.includes("Männer") && this.sessionService.profile.anrede.includes("Frau")) {
        return false;
      } else if (this.event.wertung.includes("Frauen") && this.sessionService.profile.anrede.includes("Herr")) {
        return false;
      }
    }
    return true;
  }

  getCompetitors() {
    let eventData: RanglistSearchModelByID = { eid: this.event.id, limit: 25, page: 1, start: 0 };

    this.resultService.getRangListById(eventData).then(data => {
      console.log('dataCompetitors: ', data);

      let competitors = data
      let secondsArr = [];

      for (let i = 0; i < competitors.length; i++) {
        let parts = competitors[i].timeFormatted.split(':');
        secondsArr.push((Number(parts[0]) * 3600 + Number(parts[1]) * 60 + Number(parts[2])) + "");
        competitors[i].timeFormatted = secondsArr[i];
        console.log('i=' + i)
        console.log('c.timeFormatted: ' + competitors[i].timeFormatted);
      }

      this.storageService.saveData(competitors, "participants-" + this.event.id).then((data) => {
        console.log("save participants: length = " + competitors.length);
      })
    });
  }



  register() {
    if (this.clientHella) {
      this.registrationWithId();
    } else if (this.parentInstance.hasPaymentSystem()) {
      this.registrationWithPayment();
    } else {
      this.registrationSimple();
    }
  }

  registrationWithPayment() {
    this.sessionService.getToken().then(() => {
      this.eventService.isUserRegistered(this.event.id).then(isRegistered => {
        this.isRegistered = isRegistered;
        if (isRegistered) {
          this.registrationSimple();
        } else {
          let lang = this.translate.getDefaultLang();
          this.eventService.getPaymentDetails(this.event.id, lang).then(paymentDetails => {
            if (paymentDetails && paymentDetails.price > 0) {

              this.parentInstance.enablePayment();
              this.parentInstance.detailPage = "details-shop";
            } else {
              this.registrationSimple();
            }
          });
        }
      });
    });
  }

  registrationWithId() {
    this.sessionService.getLogin().then(model => {
      this.eventService.getRoutesRegisteredByToken(model.email).then(routes => {
        if (routes) {
          let index = routes.indexOf(this.event.id);
          if (index == -1) {
            new Promise<any>((resolve, reject) => {
              (this.app.getRootNav() as NavController).push(IdRegistrationPage, { resolve: resolve });
            }).then((status) => {
              if (status) {
                this.eventService.saveRegisteredRoute(model.email, this.event.id);
                this.registrationSimple();
              }
            });
          } else {
            this.registrationSimple();
          }
        } else {
          new Promise<any>((resolve, reject) => {
            (this.app.getRootNav() as NavController).push(IdRegistrationPage, { resolve: resolve });
          }).then((status) => {
            this.sessionService.getLogin().then(model => {
              if (status) {
                this.eventService.saveRegisteredRoute(model.email, this.event.id);
                this.registrationSimple();
              }
            });
          });
        }
      });
    });
  }

  registrationSimple() {
    this.checkForBrowser();
    let loading = this.loadingCtrl.create({
      content: this.translate.instant('GLOBAL_LOADING')
    });
    loading.present();

    this.sessionService.getToken(false, (this.clientHella) ? false : true).then((token) => {

      this.eventService.registerForEvent(this.event.id).then((o) => {

        this.userService.getPrivateProfile().then((profile) => {

          this.getCompetitors();
          console.log('profile: ', profile);

          console.log('registerForEvent: ');

          let reg: EventRegistrationModel = {
            eventId: this.event.id,
            id: profile.id
          };

          this.strackerService.pushEventRegistration(reg).catch(err => console.log(err));

          if (o.imageLink) {
            const m = this.modalCtrl.create(PopupRegistrationComponent, { event: this.event, registration: o });
            m.onDidDismiss((option) => {
              switch (option) {
                case 0: this.onOpenStrackerPage(o); break;
                case 1: this.onOpenResultAddPage(o); break;
              }
            });
            m.present();
          }
          else {
            this.toastCtrl.create({
              message: this.translate.instant('ERROR_IN_REGISTRATION'),
              duration: 3000
            }).present();
          }
          loading.dismiss();
        });
      });
    });
  }

  onOpenResultAddPage(o) {
    this.strackerService.getFastestFinishResult(this.event.id, this.sessionService.profile.id + "").then((data: TrackerModel) => {
      console.log('data: ', data);
      GpsTracker.sumDistance = 0;
      GpsTracker.currentSpeed = "0";
      (this.app.getRootNav() as NavController).push(ResultAddPage, { token: this.sessionService.profile.id + "", imageLink: o.imageLink, event: this.event, data: data });
    });
  }

  onOpenStrackerPage(o) {
    this.strackerService.getResultPreload(this.event.id, this.sessionService.profile.id + "").then(async (data: TrackerModel) => {
      GpsTracker.sumDistance = 0;
      GpsTracker.currentSpeed = "0";

      let route = { hasRoute: false, fullPath: [] }

      if (this.event.eventType ==="R") {
        route.hasRoute = true;
        route.fullPath = Object.assign([], EventDetailsProvider.getInstance().getEventRoute(this.event.id));
      }

      let option = {
        applause: false,
        autoPause: false,
        placement: false,
        google: false
      }

      await this.storageService.checkForExistance('autopause').then(async (status) => {
        if (status) await this.storageService.getSaved('autopause').then((data) => option.autoPause = data);
      });

      await this.storageService.checkForExistance('applause').then(async (status) => {
        if (status) await this.storageService.getSaved('applause').then((data) => option.applause = data);
      });

      await this.storageService.checkForExistance('placement').then(async (status) => {
        if (status) await this.storageService.getSaved('placement').then((data) => option.placement = data);
      });

      await this.storageService.checkForExistance('google').then(async (status) => {
        if (status) await this.storageService.getSaved('google').then((data) => option.google = data);
      });

      console.log('route: ', route);

      (this.app.getRootNav() as NavController).push(StrackerPage, { event: this.event, imageLink: o, data: data, token: this.sessionService.profile.id + "", route: route, option: option });
    });
  }

  async ngAfterViewInit() {
    this.createFileInput();
    this.showMark = (await this.config.config).showHide.eventMark;
    console.log(this.event);
  }

  test() {
    console.log(this.myPlaceholder);
    this.client.arrowPressed = !this.client.arrowPressed;
    this.myPlaceholder.value = (this.client.arrowPressed) ? "pünktlich" : "";
  }

  openTracking() {
    let loading = this.loadingCtrl.create({
      content: this.translate.instant('GLOBAL_LOADING')
    });
    loading.present();
    this.nearbyMainResolver.doResolve([this.event]).then(data => {
      console.log('data: ', data);
      (this.app.getRootNav() as NavController).push(NearbyMapPage, { events: data }).then(() => loading.dismiss());
    });
  }

  initImages() {
    this.titleImage = this.event.images[0];
    this.filteredImages = this.event.images.slice(1, 4);
  }

  ngOnInit() {
    this.initImages();
    this.categoryService.getEventCategoires().then(categories => {
      console.log(categories);
      let category = categories.find(x => x.id === this.event.cid);
      console.log(category);
      if (!category) {
        return;
      }
      let uniqueName = category.uniqueName.toLowerCase();
      if (uniqueName.indexOf('duathlon')) {
        this.routes.push({
          name: 'run',
          route: null,
          index: 1
        });
        this.routes.push({
          name: 'bike',
          route: null,
          index: 2
        });
        this.routes.push({
          name: 'run',
          route: null,
          index: 3
        });
        //run,bike,run
      } else if (uniqueName.indexOf('tri')) {
        // swim,bike,run
        this.routes.push({
          name: 'swim',
          route: null,
          index: 1
        });
        this.routes.push({
          name: 'bike',
          route: null,
          index: 2
        });
        this.routes.push({
          name: 'run',
          route: null,
          index: 3
        });
      } else {
        this.routes.push({
          name: category.name,
          route: null,
          index: 1
        });
        //category.name
      }
    });
  }

  showAllPhoto() {
    const editEmitter = new EventEmitter();
    const deleteEmitter = new EventEmitter();
    editEmitter.subscribe((data) => console.log(data));
    deleteEmitter.subscribe((data) => console.log(data));
    const photoModal = this.modalCtrl.create(PictureViewerPage, {
      emitter: editEmitter,
      emitter1: deleteEmitter,
      pictures: this.event.images,
      activeIndex: 0,
      icon: this.event.isOwner ? 'refresh' : null,
      icon1: this.event.isOwner ? 'trash' : null
    });
    photoModal.present();
    photoModal.onDidDismiss(() => {
      editEmitter.unsubscribe();
      deleteEmitter.unsubscribe();
    });
  }

  showAllPhotoByItem(item) {
    const editEmitter = new EventEmitter();
    const deleteEmitter = new EventEmitter();
    editEmitter.subscribe((data) => this.pictureRotated(data));
    deleteEmitter.subscribe((data) => this.deletePics(data));
    const index = this.event.images.findIndex(x => x.id === item.id);
    const photoModal = this.modalCtrl.create(PictureViewerPage, {
      emitter: editEmitter,
      emitter1: deleteEmitter,
      pictures: this.event.images,
      activeIndex: index,
      icon: this.event.isOwner ? 'refresh' : null,
      icon1: this.event.isOwner ? 'trash' : null
    });
    photoModal.present();
    photoModal.onDidDismiss(() => {
      editEmitter.unsubscribe();
      deleteEmitter.unsubscribe();
    });
  }


  async pictureRotated(event: any) {
    let loader = this.loadingCtrl.create({
      content: this.translate.instant('GLOBAL_LOADING')
    });
    await loader.present();
    let model = event.list[event.index];

    let base64ImageSrc = model.imageLink;
    let that = this;
    let img = new Image();
    img.setAttribute('crossOrigin', 'anonymous');

    img.onload = async () => {
      let c = document.createElement('canvas');
      c.width = img.height;
      c.height = img.width;
      let ctx = c.getContext('2d');
      ctx.rotate((90 * Math.PI) / 180);
      ctx.drawImage(img, 0, -img.height);
      let base = c.toDataURL();
      let that = this;

      console.log('base: ' + base);
      console.log('base.length' + base.length);

      console.log(base.length);
      if (base.length > 6) {
        // let photo = await that.userService.createPhoto(model.id, base);
        // that.userService.removePhoto(model.id);
        // event.list[event.index] = photo;
        // event.list[event.index].id = photo.id;

        event.list[event.index].imageLink = base;

        const photo = await this.eventService.createEventImg(that.event.name, that.event.place, event.list[event.index].imageLink);
        that.userService.removeEventPhoto(model.id, that.event.name, that.event.place);

        // event.list[event.index] = photo;

        event.list[event.index].id = photo.id;

        that.changeDetector.markForCheck();
        that.changeDetector.detectChanges();
      }
      loader.dismiss();
    };
    img.src = base64ImageSrc;
  }

  async deletePics(event: any) {
    console.log(event);

    let loader = this.loadingCtrl.create({
      content: this.translate.instant('GLOBAL_LOADING')
    });
    await loader.present();
    const removed = await this.userService.removeEventPhoto(event.list[event.index].id, this.event.name, this.event.place);
    // const removed = await this.eventService.removePic(event.list[event.index]);
    this.event.images.splice(event.index, 1);
    this.initImages();

    loader.dismiss();

  }

  getRouteByIndex(route) {
    this.eventService.getEventRouteByIndex(this.event.id, this.event.cid, route.index).then(model => {
      (this.app.getRootNav() as NavController).push(EventDetailsMapPage, {
        event: this.event,
        route: model
      });
    });
  }


  uploadImage(data) {
    let loader = this.loadingCtrl.create({ content: 'loading' });
    loader.present();
    this.eventService.createEventImg(this.event.name, this.event.place, data).then(img => {
      this.filteredImages.push(img);
      this.event.images.push(img);
      loader.dismiss();
    });
  }

  openWebPage(url) {
    let browser = this.inAppBrowser.create(url, "_system", { hardwareback: 'yes' });
    browser.show();
  }

  fileInputClick() {
    const options: CameraOptions = {
      quality: 100,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
      correctOrientation: true
    };
    this.camera
      .getPicture(options)
      .then(photo => {
        this.uploadImage('data:image/jpeg;base64,' + photo);
      })
      .catch();
  }

  async createFileInput() {
    if (!(await this.config.config).platform.browser) return;
    if (document.querySelector('.cordova-camera-select')) return;
    try {
      const options: CameraOptions = {
        quality: 100,
        destinationType: this.camera.DestinationType.DATA_URL,
        encodingType: this.camera.EncodingType.JPEG,
        mediaType: this.camera.MediaType.PICTURE,
        sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
        correctOrientation: true
      };
      this.camera
        .getPicture(options)
        .then(photo => {
          this.uploadImage('data:image/jpeg;base64,' + photo);
          this.createFileInput();
        })
        .catch(e => {
          console.log('catched exception : ');
          console.log(e);
        });
      var input = document.querySelector('.cordova-camera-select') as HTMLElement;
      document.body.removeChild(input);

      input.style.opacity = 0 + '';
      input.style.position = 'fixed';
      input.style.height = '3.7rem';
      input.style.width = '100%';

      let button = this.uploadButton.getNativeElement() as HTMLElement;
      button.parentElement.insertBefore(input, button);
    } catch { }
  }

  onResultsRedirect() {
    var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();

    if (this.clientHella) {
      this.eventService.getPage(`event/${GlobalUtil.getInstance().currentEventID}/raceresult/url`).then((res) => {
        if (!res) {
          this.app.getRootNav().getActiveChildNav().select(1);
          this.navCtrl.popToRoot();
        } else {
          let browser = this.inAppBrowser.create(res, "_system", { hardwareback: 'yes' });
          browser.show();
          // (  this.app.getRootNav() as NavController).push(InBrowserPage, { link: res });
        }
      });
    } else if (this.appDetector.isThurnauApp() || this.appDetector.isHannoverApp()) {
      (this.app.getRootNav() as NavController).popToRoot();
      this.app.getRootNav().getActiveChildNav().select(2);
    } else if (this.appDetector.isEventsApp() && this.isBrowser) {
      (this.app.getRootNav() as NavController).push(ResultSearchPage);
    } else {
      (this.app.getRootNav() as NavController).popToRoot();
      this.app.getRootNav().getActiveChildNav().select(1);

    }

    loader.dismiss();
  }

  markEvent() {
    this.eventService.addToFavorit(this.event.id).then(succ => {
      if (succ) {
        this.toastCtrl
          .create({
            message: this.translate.instant('EVENT_ADDED_TOAST'),
            duration: 2000
          })
          .present();
      } else {
        this.toastCtrl
          .create({
            message: this.translate.instant('EVENT_ADD_FAILED_TOAST'),
            duration: 2000
          })
          .present();
      }
    });
  }

  reg() {
    this.eventService.addToRegistred(this.event.id).then(succ => {
      if (succ) {
        this.toastCtrl
          .create({
            message: this.translate.instant('EVENT_ADDED_TOAST'),
            duration: 2000
          })
          .present();
      } else {
        this.toastCtrl
          .create({
            message: this.translate.instant('EVENT_ADD_FAILED_TOAST'),
            duration: 2000
          })
          .present();
      }
    });
  }

  dummyInitialize() {
    this.options.push("pünktlich");
    this.options.push("5 min später");
    this.options.push("10 min später");
    this.options.push("15 min später");
  }


  toastMessage(message, duration, position = "top") {
    this.toastCtrl.create({
      message: message,
      duration: duration,
      position: position
    }).present();
  }

}



// WEBPACK FOOTER //
// /src/pages/event/details/event-details-new-design/event-details-new-design.ts